"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const question_renderer_1 = require("./component/question-renderer");
const question_index_1 = require("./component/question-index");
const icons_material_1 = require("@mui/icons-material");
const icon_button_1 = require("../../component/input/icon-button");
const log_1 = require("../../model/log");
const QuizRendererInner = (0, react_1.memo)(({ questions, userAnswers, onAnswerChanged, initialIndex = 0, actionComponent, sx, skipEnabled = false, }) => {
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(initialIndex);
    const theme = (0, material_1.useTheme)();
    const currentQuestion = (0, react_1.useMemo)(() => questions[currentIndex], [questions, currentIndex]);
    const handleNextQuestion = (0, react_1.useCallback)(() => {
        if (currentIndex < questions.length - 1) {
            setCurrentIndex((prev) => prev + 1);
        }
    }, [currentIndex, questions.length]);
    const handlePreviousQuestion = (0, react_1.useCallback)(() => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    }, [currentIndex]);
    const isPreviousDisabled = (0, react_1.useMemo)(() => {
        return currentIndex === 0;
    }, [currentIndex]);
    const isNextDisabled = (0, react_1.useMemo)(() => {
        return (currentIndex === questions.length - 1 ||
            !(userAnswers === null || userAnswers === void 0 ? void 0 : userAnswers.get(currentQuestion.id)));
    }, [currentIndex, currentQuestion.id, questions.length, userAnswers]);
    const handleAnswerChange = (0, react_1.useCallback)((answer) => {
        if (onAnswerChanged) {
            onAnswerChanged(currentQuestion.id, answer);
        }
    }, [currentQuestion.id, onAnswerChanged]);
    const handleClickIndex = (0, react_1.useCallback)((index) => {
        setCurrentIndex(index);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { flex: 1, direction: "column", spacing: 5, sx: sx, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 2, width: "100%", paddingX: 6, children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", justifyContent: "start", alignItems: "center", spacing: 4, flex: 1, sx: {
                            overflowX: "auto",
                        }, children: questions.map((question, index) => ((0, jsx_runtime_1.jsx)(question_index_1.QuestionIndex, { index: index, isSelected: currentIndex === index, onClick: handleClickIndex, answer: userAnswers === null || userAnswers === void 0 ? void 0 : userAnswers.get(question.id), enable: skipEnabled ||
                                currentIndex >= index ||
                                (currentIndex + 1 === index && !isNextDisabled) }, question.id))) }), (0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", alignItems: "center", spacing: 2, children: actionComponent })] }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", flex: 1, children: [(0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { onClick: handlePreviousQuestion, disabled: isPreviousDisabled, sx: {
                            padding: 0,
                        }, eventName: log_1.LogEventClickName.QuizPreviousQueation, children: (0, jsx_runtime_1.jsx)(icons_material_1.KeyboardDoubleArrowLeft, { color: isPreviousDisabled ? "disabled" : "primary", sx: {
                                fontSize: theme.spacing(6),
                            } }) }), (0, jsx_runtime_1.jsx)(question_renderer_1.QuestionRenderer, { question: currentQuestion, onAnswerChange: handleAnswerChange, sx: { flex: 1, height: "100%" }, userAnswerState: userAnswers === null || userAnswers === void 0 ? void 0 : userAnswers.get(currentQuestion.id) }, currentQuestion.id), (0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { onClick: handleNextQuestion, disabled: isNextDisabled, sx: {
                            padding: 0,
                        }, eventName: log_1.LogEventClickName.QuizNextQuestion, children: (0, jsx_runtime_1.jsx)(icons_material_1.KeyboardDoubleArrowRight, { color: isNextDisabled ? "disabled" : "primary", sx: {
                                fontSize: theme.spacing(6),
                            } }) })] })] }));
});
QuizRendererInner.displayName = "QuizRenderer";
exports.QuizRenderer = QuizRendererInner;
